'use client';

import { useQuery } from '@tanstack/react-query';
import { buildFailClosedFeatureStateMap } from '@loamify/feature-flags';
import { api } from '@loamify/shared-utils';
import { FeatureFlagsProvider as BaseFeatureFlagsProvider } from '@loamify/feature-flags/react';
import { FeatureKey } from '@loamify/feature-flags';
import type { ReactNode } from 'react';

type FeatureStateMap = Readonly<Record<FeatureKey, boolean>>;

const FAIL_CLOSED_STATES = buildFailClosedFeatureStateMap();

export function FeatureFlagsProvider({ children }: { children: ReactNode }) {
  const query = useQuery({
    queryKey: ['platform-features', 'admin'],
    queryFn: () => api.getFeatures(),
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  const states =
    query.isError || !query.data?.features
      ? FAIL_CLOSED_STATES
      : (query.data.features as FeatureStateMap);

  return <BaseFeatureFlagsProvider states={states}>{children}</BaseFeatureFlagsProvider>;
}
